import { UserContext } from "context/user.context";
import { marketingAdminRoutes, superAdminRoutes, accountAdminRoutes } from "../routes";
import { useContext } from "react";

export default function useAdminRoute() {
  const [user] = useContext(UserContext);

  let routes = marketingAdminRoutes;

  const rolesRoutes = {
    2: marketingAdminRoutes,
    // 2: superAdminRoutes,
    3: accountAdminRoutes,
    4: superAdminRoutes,
  };
  if (user?.user?.role_id) {
    routes = rolesRoutes[user?.user?.role_id];
  }
  // return superAdminRoutes;
  return routes;
}
